import React from 'react'
import Link from 'gatsby-link'
import { Grid, Icon } from 'semantic-ui-react'

import '../../styles/semantic.css'
import '../../styles/site.scss'

const iconStyle = {
  backgroundColor: 'white'
}

const footerBgStyle = {
  backgroundColor: '#141414'
}

const Footer = ({ data }) => (
  <Grid padded centered columns={1} style={footerBgStyle}>
    <Grid.Row color='black' style={{ paddingTop: '1.5rem' }}>
      <Grid.Column textAlign='center' mobile={10} tablet={6} computer={4}>
        <Grid centered columns={2}>
          <Grid.Row>
            <Grid.Column floated='right' textAlign='right'>
              <a href='https://www.instagram.com/closet_minimal'>
                <Icon size='large' color='black' circular fitted name='instagram' style={iconStyle} />
              </a>
            </Grid.Column>
            <Grid.Column floated='left'>
              <a href='https://twitter.com/Closet_Minimal'>
                <Icon size='large' color='black' circular fitted name='twitter' style={iconStyle} />
              </a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row color='black'>
      <Grid.Column textAlign='center' mobile={10} tablet={6} computer={4}>
        <p>Closet Minimal © 2018</p>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js